import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter, Mail, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-white/5" data-testid="main-footer">
      <div className="max-w-[1920px] mx-auto">
        {/* Massive Brand Name */}
        <div className="container-padding py-20 md:py-32 border-b border-white/5">
          <h2
            className="font-heading text-[15vw] leading-none tracking-tighter text-primary/10 font-light"
            data-testid="footer-brand-text"
          >
            SARVATRA
          </h2>
        </div>

        {/* Footer Content */}
        <div className="container-padding py-16 md:py-20">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-16">
            {/* About */}
            <div data-testid="footer-about-section">
              <h3 className="font-heading text-xl md:text-2xl text-primary mb-6">
                Journeys Without Boundaries
              </h3>
              <p className="text-muted-foreground text-sm leading-relaxed">
                Sarvatra Journeys is a luxury travel concierge specializing in bespoke and
                ultra-premium travel experiences across the globe.
              </p>
            </div>

            {/* Quick Links */}
            <div data-testid="footer-links-section">
              <h4 className="font-body text-xs uppercase tracking-widest text-primary mb-6">
                Explore
              </h4>
              <ul className="space-y-3">
                {['About', 'Destinations', 'Experiences', 'Itineraries', 'Journal'].map(
                  (item) => (
                    <li key={item}>
                      <Link
                        to={`/${item.toLowerCase()}`}
                        data-testid={`footer-link-${item.toLowerCase()}`}
                        className="text-muted-foreground text-sm hover:text-primary transition-colors duration-300"
                      >
                        {item}
                      </Link>
                    </li>
                  )
                )}
              </ul>
            </div>

            {/* Contact */}
            <div data-testid="footer-contact-section">
              <h4 className="font-body text-xs uppercase tracking-widest text-primary mb-6">
                Contact
              </h4>
              <ul className="space-y-3">
                <li className="flex items-center gap-3 text-muted-foreground text-sm">
                  <Mail size={16} />
                  <span>reservations@sarvatrajourneys.com</span>
                </li>
                <li className="flex items-center gap-3 text-muted-foreground text-sm">
                  <Phone size={16} />
                  <span>+91 - 7310630006</span>
                </li>
                <li className="flex items-center gap-3 text-muted-foreground text-sm">
                  <Phone size={16} />
                  <span>+91 - 9871769006</span>
                </li>
              </ul>
            </div>

            {/* Social */}
            <div data-testid="footer-social-section">
              <h4 className="font-body text-xs uppercase tracking-widest text-primary mb-6">
                Follow Us
              </h4>
              <div className="flex gap-4">
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-instagram-link"
                  className="w-10 h-10 rounded-full border border-primary/20 flex items-center justify-center text-primary hover:bg-primary hover:text-background transition-all duration-300"
                  aria-label="Instagram"
                >
                  <Instagram size={18} />
                </a>
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-facebook-link"
                  className="w-10 h-10 rounded-full border border-primary/20 flex items-center justify-center text-primary hover:bg-primary hover:text-background transition-all duration-300"
                  aria-label="Facebook"
                >
                  <Facebook size={18} />
                </a>
                <a
                  href="https://twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-twitter-link"
                  className="w-10 h-10 rounded-full border border-primary/20 flex items-center justify-center text-primary hover:bg-primary hover:text-background transition-all duration-300"
                  aria-label="Twitter"
                >
                  <Twitter size={18} />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="container-padding py-8 border-t border-white/5">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-muted-foreground text-xs" data-testid="footer-copyright">
              © 2026 Sarvatra Journeys. All rights reserved.
            </p>
            <p className="text-muted-foreground text-xs italic" data-testid="footer-tagline">
              The Art of Bespoke Travel
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;